var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "align-items-center" },
    [
      _c(
        "b-col",
        { attrs: { id: _vm.parentId } },
        [
          _c("document-classification-select", {
            attrs: {
              id: _vm.id,
              "select-dropdown-parent": "#" + _vm.parentId,
              classifications: _vm.DOCUMENT_TYPES_SELECT,
              loading: _vm.creating,
              disabled: _vm.creating,
              value: _vm.value.id,
              "loader-position": "right",
            },
            on: { change: _vm.handleClassificationSelection },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }